// removed by extract-text-webpack-plugin
module.exports = {"seoHeading":"_9xGgm","seoSubHeading":"_3rLT9","searchControls":"_12kMA"};